module.exports = __webpack_public_path__ + "static/media/tier-3.69be5357.jpg";